import { render, staticRenderFns } from "./Goal.vue?vue&type=template&id=f3a47c5a&scoped=true&"
import script from "./Goal.vue?vue&type=script&lang=js&"
export * from "./Goal.vue?vue&type=script&lang=js&"
import style0 from "./Goal.vue?vue&type=style&index=0&id=f3a47c5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a47c5a",
  null
  
)

export default component.exports